import React from "react";
import { IMenuItem } from "@trussle/external-components";

import { IMenuItemFromContentful, MENU_ITEM_CHILDREN } from "./types";
import { HubSpotForm } from "../HubSpot/HubSpotForm";
import { useHubspotFormBlocked } from "../HubSpot/BlockFeatureBySubscription/useHubspotFormBlocked";

export const swapChildrenTypeWithComponent = (menuItems: IMenuItemFromContentful[], id?: string): IMenuItem[] => {
  const { shouldShowHubspotModal, onFormSubmitted } = useHubspotFormBlocked("", 0, true);

  return menuItems.map((menuItem) => {
    switch (menuItem.childrenType) {
      case MENU_ITEM_CHILDREN.EMAIL_WIDGET:
        if (shouldShowHubspotModal) {
          const childElement = (
            <div className="hubspot-email-widget-form">
              <HubSpotForm
                hubSpotPortalId={HUBSPOT_EMAIL_WIDGET_PORTAL_ID}
                hubSpotFormId={HUBSPOT_EMAIL_WIDGET_FORM_ID}
                index={id ?? "1"}
                onFormSubmitted={onFormSubmitted}
              />
            </div>
          );

          return { ...menuItem, children: childElement };
        }
        return menuItem;
      default:
        return menuItem;
    }
  });
};
